import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDnGicna-cVS1pOz9JpVw8twlZfWA3gfLA",
  authDomain: "iba-pss.firebaseapp.com",
  projectId: "iba-pss",
  storageBucket: "iba-pss.appspot.com",
  messagingSenderId: "161215547429",
  appId: "1:161215547429:web:be97b0a8b064776e8657cc",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

//exporting firebase services
export { db, auth, storage };
